"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Slider_1 = __importDefault(require("@material-ui/core/Slider"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const theme_1 = __importDefault(require("../styles/theme"));
/**
 * Slider Usage Examples:
 *
 *  <Slider
 *    defaultValue={20}
 *    getAriaValueText={valuetext}
 *    aria-labelledby="discrete-slider-custom"
 *    step={10}
 *    valueLabelDisplay="auto"
 *  />
 *
 *  See https://v4.mui.com/api/slider/ for more documentations about the props
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const HtmlTooltip = styles_1.withStyles(() => ({
    tooltip: {
        backgroundColor: theme_1.default.colors.white,
        border: '1px solid #E6E8ED',
        color: theme_1.default.colors.textDefault,
        fontSize: 13,
        textAlign: 'center',
    },
    arrow: {
        color: theme_1.default.colors.white,
        '&:before': {
            border: '1px solid #E6E8ED',
        },
    },
}))(Tooltip_1.default);
const StyledSlider = styles_1.withStyles({
    root: {
        color: theme_1.default.colors.primaryAccent,
        height: 8,
        width: 'calc(100% - 8px)',
    },
    thumb: {
        height: 20,
        width: 20,
        backgroundColor: '#fff',
        border: '4px solid currentColor',
        marginTop: -5,
        marginLeft: -10,
        '&:focus, &:hover, &$active': {
            boxShadow: 'inherit',
        },
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)',
    },
    track: {
        height: 10,
        borderRadius: 2,
        color: theme_1.default.colors.primaryAccent,
    },
    rail: {
        height: 10,
        borderRadius: 2,
        color: theme_1.default.colors.borderDefault,
    },
})(Slider_1.default);
const ValueLabelComponent = (p) => {
    const { children, open, value } = p;
    return (react_1.default.createElement(HtmlTooltip, { open: open, enterTouchDelay: 0, placement: "top", title: value, arrow: true, PopperProps: {
            disablePortal: true,
            modifiers: {
                flip: {
                    enabled: false,
                },
                preventOverflow: {
                    enabled: true,
                    priority: ['left', 'right'],
                },
            },
        } }, children));
};
const Slider = (_a) => {
    var { ariaLabel = 'Choose a value', className, getValueLabel, marginTop = 40, max = 100, min = 0, defaultValue = Math.min(0, min), onChange, onChangeCommitted, value } = _a, props = __rest(_a, ["ariaLabel", "className", "getValueLabel", "marginTop", "max", "min", "defaultValue", "onChange", "onChangeCommitted", "value"]);
    return (react_1.default.createElement(StyledSlider, Object.assign({ className: className, "aria-label": ariaLabel, defaultValue: defaultValue, ValueLabelComponent: ValueLabelComponent, "data-testid": "slider", onChange: (event, val) => {
            if (onChange) {
                onChange(val, event);
            }
        }, onChangeCommitted: (event, val) => {
            if (onChangeCommitted) {
                onChangeCommitted(val, event);
            }
        }, max: max, min: min, style: Object.assign(Object.assign({}, props.style), { marginTop }), value: value, valueLabelFormat: getValueLabel }, props)));
};
exports.Slider = Slider;
exports.default = exports.Slider;
